// module.exports = {
// 	name: 'Octopharma - Mirta web app',
// 	shortName: 'Mirta',
// 	description: 'Octopharma portal version of the mobile app',
// 	primaryColor: '#02855b',
// 	secondaryColor: '#13a689',
// 	msTileColor: '#02855b'
// }

// rama pharma config
// module.exports = {
// 	name: 'Rama Pharma - Rama Pharma web app',
// 	shortName: 'Rama Pharma',
// 	description: 'Rama Pharma portal version of the mobile app',
// 	primaryColor: '#004a98',
// 	secondaryColor: '#f57f20',
// 	msTileColor: '#004a98'
// }

// ibn alhaytham
// module.exports = {
// 	name: 'Ibn Alhaytham - Ibn Alhaytham web app',
// 	shortName: 'Ibn Alhaytham',
// 	description: 'Ibn Alhaytham portal version of the mobile app',
// 	primaryColor: '#0886a5',
// 	secondaryColor: '#f57f20',
// 	msTileColor: '#0886a5'
// }

// right
// module.exports = {
// 	name: 'Octopharma - Right web app',
// 	shortName: 'Right',
// 	description: 'Octopharma portal version of the mobile app',
// 	primaryColor: '#02855b',
// 	secondaryColor: '#13a689',
// 	msTileColor: '#02855b'
// }

// Al khalil
module.exports = {
	name: 'Alkhalil - Alkhalil web app',
	shortName: 'Alkhalil',
	description: 'Alkhalil portal version of the mobile app',
	primaryColor: '#27327b',
	secondaryColor: '#156546',
	msTileColor: '#2a669b'
}

// media pharma
module.exports = {
	name: 'Octopharma - Mirta web app',
	shortName: 'Mirta',
	description: 'Octopharma portal version of the mobile app',
	primaryColor: '#02855b',
	secondaryColor: '#13a689',
	msTileColor: '#02855b'
}
